import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id B81435D3-9FE4-470D-A46A-7FEDA1773D15
 * name tray-full
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tray-full.svg
 * tags
 */
export const TrayFullIcon = createSvgIcon(<><path d="M18 5H6V7H18M6 9H18V11H6M2 12H4V17H20V12H22V17A2 2 0 0 1 20 19H4A2 2 0 0 1 2 17M18 13H6V15H18Z" /></>, 'TrayFullIcon');
export default TrayFullIcon